import * as React from "react";
import { Paper, Button, IconButton, Menu, MenuItem } from "@mui/material";
import { styled } from '@mui/material/styles';
import {
  ErrorOutlineOutlined as ErroIcon,
  MoreVert as MoreVertIcon,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

const FloatingControlsPaper = styled(Paper)({
  position: "fixed",
  bottom: "0",
  right: "0",
  padding: 6,
  zIndex: 100,
  borderBottomRightRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 0,
});

const ErrorIconStyled = styled(ErroIcon)({
  margin: "0 5px",
  position: "relative",
  top: "0.3em",
});

interface FormActionsProps {
  templateKey: string;
  websiteKey: string;
  formIsValid: boolean;
  onBuildClick: (e: any) => void | Promise<void>;
  onSaveClick: (e: any) => void | Promise<void>;
}

interface FormActionsState {
  menuOpen: boolean;
  menuAnchor: any | null;
}

export class FormActions extends React.Component<FormActionsProps> {

  state: FormActionsState = {
    menuOpen: false,
    menuAnchor: null
  };

  private handleMoreActionClick = (e: any) => {
    this.setState({ menuOpen: true, menuAnchor: e.target });
  };

  private hideMenu = (e: any) => {
    this.setState({ menuOpen: false });
  };

  render() {
    const {
      formIsValid,
      onBuildClick,
      onSaveClick,
      templateKey,
      websiteKey
    } = this.props;

    return (
      <FloatingControlsPaper>
        <Button style={{ margin: 6 }} onClick={onSaveClick} >
          Save
        </Button>
        {!formIsValid && (
          <ErrorIconStyled color="error" />
        )}
        <Button style={{ margin: 6 }} variant="contained" color="primary" disabled={!formIsValid} onClick={onBuildClick} >
          Build
        </Button>
        <IconButton onClick={this.handleMoreActionClick} size="large">
          <MoreVertIcon />
        </IconButton>
        <Menu
          open={this.state.menuOpen}
          anchorEl={this.state.menuAnchor}
          onClose={this.hideMenu}
        >
          <MenuItem
            onClick={this.hideMenu}
            component="a"
            href={`http://${templateKey}--${this.props.websiteKey}.hugosites.webdrvn.com`}
            target="_blank"
          >
            Preview
          </MenuItem>
          <MenuItem
            component={React.forwardRef((itemProps: any, ref: any) => (
              <Link ref={ref} to={`/websites/${templateKey}/${websiteKey}/deploy`} {...itemProps} />
            ))}
          >
            Deploy
          </MenuItem>
        </Menu>
      </FloatingControlsPaper>
    );
  }
}
